module.exports = __webpack_public_path__ + "4bf8a5371c2c53827de759056a58432a.svg";